import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcVisibility24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 5c3.688 0 6.406 2.188 9.781 6.375a.955.955 0 0 1 .219.625.955.955 0 0 1 -.219.625c-3.375 4.219-6.093 6.375-9.781 6.375-3.469 0-5.938-1.688-9.781-6.375a.955.955 0 0 1 -.219-.625c0-.219.063-.438.219-.625 3.375-4.188 6.094-6.375 9.781-6.375zm0 2c-2.531 0-4.688 1.406-7.719 5 2.939 3.5 4.969 4.906 7.719 5 2.531 0 4.688-1.406 7.719-5-2.939-3.5-4.969-4.906-7.719-5zm0 2a3 3 0 1 1 -.002 6.002 3 3 0 0 1 .002-6.002zm0 2c-.563 0-1 .469-1 1 0 .563.438 1.031 1 1.031.563 0 1-.469 1-1.031 0-.531-.438-1-1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcVisibility24;
